/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form,Radio } from 'antd';
import {layout, Button} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import IconFont from 'Components/common/iconFont';
import TaskProgress from 'Components/taskProgress';
import tListActions from 'Actions/taskManage/list';
import Search from './search';
import Tabs from './tabs';
import TableList from './tableList';
import EditModal from './modal/editModal';

import './index.less';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;

class List extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false, // 列表loading
      isEditModalVisible: false, // 编辑弹框是否可见
      toneList:[],//音色列表
      questionRating:''
    };
  }
  componentDidMount(){
    //获取音色列表
    const {actions} = this.props;
    actions.getTonelList().then(res=>{
      if(res.payload.code==200){
        this.setState({toneList:res.payload.data});
      }
    })
  
  }
  componentWillUnmount() {
    const {actions} = this.props;

    actions.setSearchData({progress: -1});
    actions.setTabActiveKey('-1');
    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 设置编辑弹框显示隐藏
  setEditModalVisible = () => {
    const {isEditModalVisible} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isEditModalVisible: !isEditModalVisible,
      },
      () => {
        const {isEditModalVisible: currentIsEditModalVisible} = this.state;

        if (!currentIsEditModalVisible) {
          actions.setEditModalData({});
        }
      },
    );
  };

  render() {
    const {tableListLoading, isEditModalVisible,toneList} = this.state;
    const {login} = this.props;
    return (
      <div className="taskManageList">
        <BaseContentMainHeader title="任务列表">
          <Form layout="inline">
            {login.permissionsList.includes('taskManageList.createTask') ?
              <FormItem>
                <Button type="success" onClick={this.setEditModalVisible}>
                  <IconFont type="icon-robotadd" />创建任务
                </Button>
              </FormItem>
              : null
            }
            <FormItem>
              <TaskProgress />
            </FormItem>
          </Form>
        </BaseContentMainHeader>

        <Search getTableList={this.getCustomizeTableList} />

        <Tabs getTableList={this.getCustomizeTableList} />

        <TableList
          loading={tableListLoading}
          setTableListLoading={this.setTableListLoading}
          getTableList={this.getCustomizeTableList}
          setEditModalVisible={this.setEditModalVisible}
        />
        {isEditModalVisible ? (
          <EditModal
            toneList={toneList}
            getTableList={this.getCustomizeTableList}
            setEditModalVisible={this.setEditModalVisible}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  taskManageList: state.taskManageList,
  login:state.login
});

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(tListActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List);
